import { useEffect } from 'react';
import { useDeviceSelectors } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import { Path } from '../../Routing/Paths';

const useIncorrectPlatformFallback = () => {
  const history = useHistory();
  const [selectors] = useDeviceSelectors(window.navigator.userAgent);

  useEffect(() => {
    if (!selectors.isSafari) {
      history.replace({
        pathname: Path.NTVPluginActivationAlternateBrowser,
        search: location.search,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectors.isSafari]);
};

export default useIncorrectPlatformFallback;
